import React from "react";
import { booleanFields } from "../../constants/templateVariants";

const formatKey = (key) =>
  key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

const RdvDetails = ({ rdv }) => {
  return (
    <div className="rdv-details p-3 p-md-4">
      {/* En-tête principal */}
      <div className="text-center mb-4">
        <h2 className="text-primary mb-1">
          {rdv.client_prenom}{" "}
          <span className="text-uppercase">
            <strong>{rdv.client_nom}</strong>
          </span>
        </h2>
      </div>

      {/* Informations générales */}
      <div className="bg-body rounded shadow-sm p-3 mb-3">
        <h5 className="mb-3">👤 Informations générales</h5>
        <div className="row">
          <div className="col-lg-6 mb-2">
            <strong>Email :</strong> {rdv.client_email}
          </div>
          <div className="col-lg-6 mb-2">
            <strong>Téléphone :</strong> {rdv.client_tel}
          </div>
          <div className="col-lg-6 mb-2">
            <strong>Date du RDV :</strong>{" "}
            {new Date(rdv.date_prise_rdv).toLocaleString()}
          </div>
          {rdv.commentaires && (
            <div className="col-12 mb-2">
              <strong>Commentaires :</strong> {rdv.commentaires}
            </div>
          )}
        </div>
      </div>

      {/* Préférences */}
      {booleanFields.some((field) => Boolean(rdv[field])) && (
        <div className="bg-body rounded shadow-sm p-3 mb-3">
          <h5 className="mb-3">💅 Prestations demandées</h5>
          <div className="d-flex gap-2">
            {booleanFields.map((field) =>
              rdv[field] ? (
                <div key={field} className="mb-2 gap-3">
                  <div className="badge bg-success-subtle text-success-emphasis rounded p-2 fs-5">
                    <strong>{formatKey(field)}</strong>
                  </div>
                </div>
              ) : null
            )}
          </div>

          {/* Si "autres" = true → afficher le détail */}
          {Boolean(rdv.autres) && rdv.autres_details && (
            <div className="row mt-2">
              <div className="col-12">
                <strong>Autres détails :</strong> {rdv.autres_details}
              </div>
            </div>
          )}
        </div>
      )}

      {/* Date de création */}
      <div className="bg-body rounded shadow-sm p-3 text-muted d-flex align-items-center gap-2">
        <i className="bi bi-clock"></i>
        <span>
          <strong>Ajouté :</strong> {new Date(rdv.created_at).toLocaleString()}
        </span>
      </div>
    </div>
  );
};

export default RdvDetails;
